module.exports = __webpack_public_path__ + "static/media/light-hash-left-1.c2380f02.svg";